<template>
  <div class="crew_right">
    <div class="conInner">
      <div class="data">
        <h2>修改密码</h2>
      </div>
      <!--温馨提示-->
      <div class="tip">
        <div class="top"></div>
        <div class="body">
          <img src="//static.kxymall.com/images/gth.jpg">
          <div>
            <h2>温馨提示</h2>
            <p>1、密码只能为6--16个英文字母或数字</p>
            <p>2、为了您的账号安全，必须正确输入旧密码才能修改。</p>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
      <!--温馨提示结束-->
      <div
        class="form_wrap white_box"
        style="margin-top:20px"
      >
        <div class="box">
          <div class="top"></div>
          <div class="body">
            <Form
              ref="pwdForm"
              :model="pwdForm"
              :rules="ruleCustom"
              :label-width="150"
              class="pwd-panel"
            >
              <FormItem
                label="旧的登录密码"
                prop="oldpwd"
              >
                <Input
                  type="password"
                  v-model="pwdForm.oldpwd"
                  class="form-input"
                ></Input>
              </FormItem>
              <FormItem
                label="新的登录密码"
                prop="newpwd"
              >
                <Input
                  type="password"
                  v-model="pwdForm.newpwd"
                  class="form-input"
                ></Input>
              </FormItem>
              <FormItem
                label="确认新登录密码"
                prop="checkpws"
              >
                <Input
                  type="password"
                  v-model="pwdForm.checkpws"
                  class="form-input"
                ></Input>
              </FormItem>
              <FormItem>
                <Button @click="updatePwd('pwdForm')">确定修改</Button>
              </FormItem>
            </Form>
          </div>
          <div
            class="bottom"
            style="margin-top:-10px;"
          ></div>
        </div>
        <div class="rr_bottom"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { updatePwd } from "api/user";
import { getSession } from "utils/tool";
import { encryptDes } from "utils/des";
import encrypt from "encryptlong";
export default {
  data() {
    const validateOld = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("旧的登录密码不能为空"));
      } else {
        const patrn = /^(\w){6,16}$/;
        if (!patrn.test(value)) {
          callback(new Error("密码格式不正确"));
        } else {
          callback();
        }
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("新的登录密码不能为空"));
      } else {
        const patrn = /^(\w){6,16}$/;
        if (!patrn.test(value)) {
          callback(new Error("密码格式不正确"));
        } else {
          callback();
        }
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请确认新的登录密码"));
      } else if (value !== this.pwdForm.newpwd) {
        callback(new Error("两次登录密码输入不一致!"));
      } else {
        callback();
      }
    };
    return {
      pwdForm: {
        oldpwd: "",
        newpwd: "",
        checkpws: "",
      },
      ruleCustom: {
        oldpwd: [{ validator: validateOld, trigger: "blur" }],
        newpwd: [{ validator: validatePass, trigger: "blur" }],
        checkpws: [{ validator: validatePassCheck, trigger: "blur" }],
      },
    };
  },
  methods: {
    // 修改密码
    updatePwd(name) {
      this.$refs[name].validate((valid) => {
        const postJson = {
          loginName: getSession("userName"),
          oldPwd: this.pwdForm.oldpwd,
          newPwd: this.pwdForm.newpwd,
          platform: "GD",
          type: 1,
          sid: getSession("sid")
        };
        // const postBody = encryptDes(JSON.stringify(postJson));
        if (valid) {
          const publicKey = process.env.PUBLICKEY
          let encryptor = new encrypt();
          encryptor.setPublicKey(publicKey);
          let postBody = encryptor.encryptLong(JSON.stringify(postJson));
          updatePwd(postBody).then((resp) => {
            if (resp.resCode == 1) {
              this.$Modal.success({
                content: "修改密码成功!",
                onOk: () => {
                  this.$router.push({
                    path: "/member/member",
                  });
                },
              });
            } else {
              this.$Message.error(resp.resDesc);
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.pwd-panel {
  background-color: #fff;
}
.form-input {
  width: 200px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// security.vue?50e693b4